import {

	HomeDemo1,
	HomeDemo2,
	HomeDemo3,
	HomeDemo4,
	HomeDemo5,
	HomeDemo6,
	HomeDemo7,
	HomeDemo8,
	HomeDemo9,
	HomeDemo10,
	HomeDemo11,
	HomeDemo12,

} from '../../utils/allImgs'

const data = [
	{
		img:HomeDemo1,
		path:"/index-demo-1"
	},
	{
		img:HomeDemo2,
		path:"/index-demo-2"
	},
	{
		img:HomeDemo3,
		path:"/index-demo-3"
	},
	{
		img:HomeDemo4,
		path:"/discover"
	},
	{
		img:HomeDemo5,
		path:"/discover-3"
	},
	{
		img:HomeDemo6,
		path:"/itemdetails"
	},
	{
		img:HomeDemo7,
		path:"/connectwallet"
	},
	{
		img:HomeDemo8,
		path:"/createitem"
	},
	{
		img:HomeDemo9,
		path:"/authors"
	},
	{
		img:HomeDemo10,
		path:"/profile"
	},
	{
		img:HomeDemo11,
		path:"/index-blog-with-sidebar"
	},
	{
		img:HomeDemo12,
		path:"/index-single-blog"
	}
]



export default data